import { push } from 'react-router-redux';
import R from 'ramda';
import { getUser } from '../stores/user/user-actions';
import { getTags } from '../stores/tags/tags-actions';
import { getProfile } from '../stores/profile/company/profile-actions';
import { getBilling } from '../stores/billing/billing-actions';
import { refreshConnectionsStats } from '../stores/connections-stats/connections-stats-actions';
import { hydrateFromServer } from '../stores/settings/settings-actions';

export function hydrateStores(dispatch) {
  dispatch(getUser()).then(res => {
    if (!res) return;
    if (res.user && res.user.pureDocView) return;
    [
      getTags.bind(this, R.pathOr(null, ['user', 'company', 'companyId'], res)),
      getProfile,
      getBilling,
      refreshConnectionsStats,
      hydrateFromServer,
    ].forEach(fn => dispatch(fn()));
  });
}



// WEBPACK FOOTER //
// ./src/app/utils/hydrate-stores.js